
export default {
    name: 'collection',
    props: ['source'],
    data() {
        return {

        }
    }
}
